/**
 * Contexte de liste transmis à la page détail d'une demande de dépense
 * pour permettre la navigation précédente / suivante dans la même liste
 * (même filtres, même tri, même pagination).
 */

export const LIST_NAVIGATION_PARAM = "fromList";

export type SpendingDemandListNavigationMode = "manager" | "user";

/** Paramètre d'URL portant le numéro de page de chaque liste */
export const LIST_NAVIGATION_PAGE_PARAM: Record<SpendingDemandListNavigationMode, string> = {
  manager: "spendingdemandmanager-page",
  user: "page",
};

export const buildSpendingDemandDetailLink = (
  basePath: string,
  spendingDemandId: string,
  listSearch: string,
  mode: SpendingDemandListNavigationMode
) => {
  const params = new URLSearchParams(listSearch);
  params.set(LIST_NAVIGATION_PARAM, mode);
  return `${basePath}/${spendingDemandId}?${params.toString()}`;
};

export const getSpendingDemandListNavigationMode = (
  search: string
): SpendingDemandListNavigationMode | null => {
  const mode = new URLSearchParams(search).get(LIST_NAVIGATION_PARAM);
  return mode === "manager" || mode === "user" ? mode : null;
};

export const MANAGER_PARAM_PREFIX = "spendingdemandmanager-";

/** Ne garde que les paramètres d'URL décrivant la liste d'origine */
export const extractListParams = (search: string, mode: SpendingDemandListNavigationMode) => {
  const listParams = new URLSearchParams();
  new URLSearchParams(search).forEach((value, key) => {
    const isListParam =
      key === LIST_NAVIGATION_PARAM ||
      (mode === "manager" ? key.startsWith(MANAGER_PARAM_PREFIX) : key === LIST_NAVIGATION_PAGE_PARAM.user);
    if (isListParam) listParams.set(key, value);
  });
  return listParams;
};

/**
 * Lien de retour vers la liste d'origine, à la page atteinte avec les flèches
 * (undefined si la page détail n'a pas été ouverte depuis une liste)
 */
export const buildSpendingDemandListLink = (listPath: string, search: string) => {
  const mode = getSpendingDemandListNavigationMode(search);
  if (!mode) return undefined;
  const listParams = extractListParams(search, mode);
  listParams.delete(LIST_NAVIGATION_PARAM);
  const query = listParams.toString();
  return query ? `${listPath}?${query}` : listPath;
};
